import { useMemo } from "react";
import { useSelector } from "react-redux";

import { useIntl } from "react-intl";

import EntityType from "@mapmycustomers/shared/enum/EntityType";
import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";
import { isEntityTypeSupportingCustomSourceObject } from "@mapmycustomers/shared/util/assert";

import { getSourceObjectValues } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import { getSourceObjectLabel, hasCustomSourceObjects } from "@app/util/ui";

export interface SourceObjectOption {
  label: string;
  value: HasSourceObject["sourceObject"];
}

const useSourceObjectOptions = (entityType: EntityType | undefined): SourceObjectOption[] => {
  const intl = useIntl();
  const values = useSelector((state: RootState) => getSourceObjectValues(state, entityType));

  return useMemo(
    () =>
      hasCustomSourceObjects(values) && isEntityTypeSupportingCustomSourceObject(entityType)
        ? values.map((item) => ({
            label: getSourceObjectLabel(intl, entityType, values, item.key) ?? "",
            value: item.key,
          }))
        : [],
    [entityType, intl, values]
  );
};

export default useSourceObjectOptions;
